import { Component, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, Message, MessageService } from 'primeng/api';
import { AuthServiceService } from '../../../../shared/services/auth-service/auth-service.service';
import { SocketServiceService } from '../../../../shared/services/socket-service/socket-service.service';
import { DataSharingService } from '../../../../shared/services/data-sharing/data-sharing.service';
import { ScreenResolutionService } from '../../../../shared/services/screen-resolution/screen-resolution.service';
import { Options } from '@angular-slider/ngx-slider';
import { combineLatest } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  isBrowser = false;
  items: MenuItem[] | undefined;
  visible: boolean = false;
  profileMenu: MenuItem[] | undefined;
  accountBalance: any;
  mergedData: any = [];
  isMobile: boolean = false;
  leverage: any;
  value: number = 5;
  marginType: any = 'isolate';
  messages: any = [];
  isolateArr = [
    'Position-Specific Control',
    'Prevention of Overexposure',
    'Prevents Forced Liquidation of Entire Portfolio',
  ];
  crossArr = [
    'Optimized Margin Utilization',
    'Increased Leverage Flexibility',
    'Enhanced Capital Efficiency',
    'Lower Margin Requirements for Multiple Positions',
  ];
  options: Options = {
    showTicksValues: true,
    stepsArray: [
      { value: 10, legend: '10' },
      { value: 20, legend: '20' },
      { value: 30, legend: '30' },
      { value: 40, legend: '40' },
      { value: 50, legend: '50' },
    ],
  };
  suggestion: string[] = [
    'Apple',
    'Banana',
    'Mango',
    'Orange',
    'Pineapple',
    'Strawberry',
  ];
  marginListArr: any = [];
  filteredItems: any[] = [];
  searchTerm: string = '';
  showSuggestions: boolean = false;
  selectedMarginMode: any;
  pnlSubscription: any;
  marginTypeCond: any = '';
  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private router: Router,
    public authService: AuthServiceService,
    private dataSharingService: DataSharingService,
    private socketService: SocketServiceService,
    private screenResolution: ScreenResolutionService,
    private messageService: MessageService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    // this.marginListArr = this.isolateArr
  }

  ngOnInit() {
    this.isMobile = this.screenResolution.isMobile();
    combineLatest([
      this.dataSharingService.futuresData$,
      this.dataSharingService.optionsData$,
    ]).subscribe(([futures, options]) => {
      const futuresData = Array.isArray(futures?.futuresData)
        ? futures.futuresData
        : [];

      const optionData = Array.isArray(options?.optionData)
        ? options.optionData
        : [];
      this.mergedData = [...futuresData, ...optionData]; // Merging both arrays
    });
    this.items = [
      {
        label: 'Markets',
        icon: '',
      },
      {
        label: 'Futures',
        icon: '',
      },
      {
        label: 'Options',
        icon: '',
      },
      // {
      //   label: 'Offers',
      //   icon: '',
      // },
      // {
      //   label: 'More',
      //   icon: '',
      // }
    ];
    this.profileMenu = [
      {
        label: 'Dashboard',
        icon: 'pi pi-objects-column',
        command: () => this.onMenuSelect('dashboard'),
      },
      {
        label: 'PnL Analysis',
        icon: 'pi pi-chart-bar',
        command: () => this.onMenuSelect('pnl'),
      },
      {
        label: 'Refferal',
        icon: 'pi pi-user-plus',
        command: () => this.onMenuSelect('refferal'),
      },
      {
        separator: true,
      },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => this.onMenuSelect('logout'),
      },
    ];
    this.pnlSubscription = this.dataSharingService.pnlData$.subscribe(
      (_data: any) => {
        this.selectedMarginMode = _data?.orders?.accountData?.marginType;
        this.marginType = _data?.orders?.accountData?.marginType;
        // console.log('nl data..', this.selectedMarginMode, _data?.orders);

        if (!this.marginTypeCond) {
          this.marginTypeCond = this.marginType;
        }
        this.marginListArr =
          this.marginTypeCond == 'isolate' ? this.isolateArr : this.crossArr;
        this.accountBalance = _data?.orders?.accountData?.balance;
      },
    );

    // this.socketService.listen('update-balance').subscribe((_d: any) => {
    //   this.selectedMarginMode = _d.marginType
    //   this.marginType = _d.marginType
    //   this.marginListArr = _d.marginType == 'isolate' ? this.isolateArr : this.crossArr
    //   this.accountBalance = _d.balance;
    // });
    // this.dataSharingService.accountDetails$.subscribe((_d: any) => {
    //   if (_d.balance) {
    //     this.accountBalance = _d.balance
    //   }
    // })
    // this.dataSharingService.accountDetailsStream$.subscribe((_d: any) => {
    //   if (_d && _d.balance) {
    //     this.accountBalance = _d.balance
    //   }
    // })
  }

  changeScreen(label: string) {
    switch (label) {
      case 'Futures': {
        this.router.navigate(['/trading/futures']);
        break;
      }
      case 'Options': {
        this.router.navigate(['/trading/options']);
        break;
      }
      case 'Markets': {
        this.router.navigate(['/trading/market']);
        break;
      }
    }
  }

  onSelectProfile(data: any) {
    console.log('data...', data);
  }

  onMenuSelect(menuLabel: string) {
    switch (menuLabel) {
      case 'dashboard': {
        this.router.navigate(['dashboard']);
        break;
      }
      case 'pnl': {
        this.router.navigate(['/dashboard/analytics']);
        break;
      }
      case 'logout': {
        this.authService.logout();
        this.socketService.disconnect();
        this.router.navigate(['/user/login']);
        break;
      }
      case 'refferal': {
        this.router.navigate(['/user/refferal']);
        break;
      }
    }
  }

  navigate(url: string, tabType: string = '') {
    if (tabType) {
      this.dataSharingService.sendAccountTabType(tabType);
    }
    this.router.navigate([url]);
  }

  filterSuggestions() {
    if (this.searchTerm.trim() === '') {
      this.filteredItems = [];
      return;
    }

    this.filteredItems = this.mergedData
      .filter((item: any) =>
        item.s
          ? item.s.toLowerCase().includes(this.searchTerm.toLowerCase())
          : item.symbol.toLowerCase().includes(this.searchTerm.toLowerCase()),
      )
      .slice(0, 15);
  }

  selectItem(item: any) {
    this.searchTerm = item;
    this.showSuggestions = false;
    if (this.isBrowser) {
      localStorage.setItem('contractType', item.contractType);
      localStorage.setItem(
        'contractName',
        item.contractType == 'options' ? item.symbol : item.s,
      );
    }

    this.searchTerm = '';
    switch (item.contractType) {
      case 'options': {
        if (this.isMobile) {
          this.router.navigate(['/trading/order-execute']);
        } else {
          this.router.navigate(['/trading/options']);
        }
        break;
      }
      case 'futures': {
        // localStorage.setItem('selectedFutureContract', item.s);
        if (this.isBrowser) {
          localStorage.setItem('contractName', item.s);
        }
        this.dataSharingService.sendSelectedFuture(null);
        if (this.isMobile) {
          this.router.navigate(['/trading/order-execute']);
        } else {
          this.router.navigate(['/trading/futures']);
        }
        break;
      }
    }
  }

  hideSuggestions() {
    setTimeout(() => (this.showSuggestions = false), 200); // Delay to allow selection
  }

  onNavigation(url: string) {
    this.router.navigate([url]);
  }

  showDialog() {
    this.visible = true;
  }

  changeMarginType(type: any) {
    this.messages = [];
    this.marginType = type;
    this.marginTypeCond = type;
    if (this.marginType == 'isolate') {
      this.marginListArr = this.isolateArr;
    } else {
      this.marginListArr = this.crossArr;
    }
  }

  switchMarginMode() {
    let marginMode = {
      mode: this.marginTypeCond,
    };
    this.authService.changeMarginMode(marginMode).subscribe({
      next: (_d: any) => {
        this.messages = [];
        this.showToast('info', _d.message, 'Success');
        this.marginType = _d.marginType;
        this.marginTypeCond = _d.marginType;
        // this.selectedMarginMode = _d.marginType;
        this.visible = false;
      },
      error: (err: any) => {
        this.marginType = this.marginType == 'isolate' ? 'cross' : 'isolate';
        this.marginTypeCond =
          this.marginTypeCond == 'isolate' ? 'cross' : 'isolate';
        this.messages?.push({ severity: 'error', detail: err.error.message });
      },
    });
  }

  showToast(type: string, message: string, summary: string) {
    this.messageService.add({
      severity: type,
      summary: summary,
      detail: message,
    });
  }

  addFunds() {
    if (this.authService.isLogin()) {
      this.router.navigate(['/dashboard/add-funds'], { replaceUrl: true });
    } else {
      this.router.navigate(['/user/login']);
    }
  }
}
